import { Component, Input, OnDestroy, OnInit } from '@angular/core'
import { TranslateService } from '@ngx-translate/core'

import { Subscription } from 'rxjs'
import { MachineState } from '../../../../models/states.models'
import { TouaregControlStateParamsService } from '../../../../services/touareg-control-state-params.service'
import { TouaregControlStateLayoutComponent } from '../../layout/touareg-control-state-layout.component';

@Component({
  selector: 'app-touareg-control-state-drop',
  templateUrl: './touareg-control-state-drop.component.html',
  styleUrls: ['./touareg-control-state-drop.component.scss'],
  imports: [TouaregControlStateLayoutComponent],
})
export class TouaregControlStateDropComponent {
  @Input()
  state!: MachineState

  public countdownMessage: string

  constructor(private translate: TranslateService) {
    this.countdownMessage = this.translate.instant('touareg.droppingAssets')
  }
}
